var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormGroup",
        { staticClass: "mt-3", attrs: { state: _vm.dateValid } },
        [
          _c("RadioGroup", {
            attrs: { options: _vm.typeOptions },
            on: { input: _vm.emitChangeEvent },
            model: {
              value: _vm.type,
              callback: function($$v) {
                _vm.type = $$v
              },
              expression: "type"
            }
          }),
          _vm._v(" "),
          _vm.dateEligible
            ? _c("DatePickerCalendar", {
                attrs: { "force-min-date": new Date(), "years-in-future": 2 },
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.noticePeriodEligible
            ? _c("div", { staticClass: "mt-2 d-flex align-items-center" }, [
                _c("div", [_vm._v("Kündigungsfrist beträgt")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mx-2 w-auto" },
                  [
                    _c("Select", {
                      staticClass: "w-auto",
                      attrs: {
                        options: _vm.noticePeriodOptions,
                        "empty-value-label": "Monat(e)"
                      },
                      on: { input: _vm.emitChangeEvent },
                      model: {
                        value: _vm.noticePeriod,
                        callback: function($$v) {
                          _vm.noticePeriod = $$v
                        },
                        expression: "noticePeriod"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [_vm._v("Monat(e)")])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }